import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

interface StatusModals {
  itemQuantityAlertModal?: Boolean;
  takePillModal?: Boolean;
  popupModal?: Boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PrModalsEvent {

  private event = new BehaviorSubject<StatusModals>({
    itemQuantityAlertModal: false,
    takePillModal: false,
    popupModal: false,
  });
  statusModals = this.event.asObservable();
  private _products: any[] = [];

  get products(): any[] {
    return this._products;
  }

  changeStatusModals(status: StatusModals) {
    this.event.next(status);
  }

  changeProducts(products: any[]) {
    this._products = products;
  }
}
